import { useEffect } from "react";

/**
 * Injiziert ein JSON-LD <script> pro Route (z. B. FAQPage, BreadcrumbList).
 * Wird beim Verlassen der Seite wieder entfernt, damit kein Schema überlappt.
 */
export const JsonLd = ({ id, data }) => {
  useEffect(() => {
    const sid = `jsonld-${id}`;
    let el = document.getElementById(sid);
    if (!el) {
      el = document.createElement("script");
      el.type = "application/ld+json";
      el.id = sid;
      document.head.appendChild(el);
    }
    el.textContent = JSON.stringify(data);
    return () => {
      const e = document.getElementById(sid);
      if (e) e.remove();
    };
  }, [id, data]);
  return null;
};
